import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {Trial} from "../../model/trial";
import {Intervention} from "../../model/intervention";
import {TrialLocation} from "../../model/triallocation";

@Component({
  selector: 'gen-trial-header',
  templateUrl: './trial-header.component.html',
  styleUrls: ['./trial-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialHeaderComponent implements OnChanges {

  @Input() trial: Trial;
  visible: boolean;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.trial) {
    }
  }

  private unique(value, index, self) {
    return self.indexOf(value) === index;
  }

  public get drugs(): string {
    if (this.trial) {

      // In clinical_study, intervention can be an Intervention or an Intervention[]. Should be always an array.
      let interventions: Intervention[];
      if (this.trial.clinical_study.intervention instanceof Array) {
        interventions = this.trial.clinical_study.intervention;
      } else {
        interventions = [this.trial.clinical_study.intervention];
      }

      return this.strip(interventions
        .filter(i => i.intervention_type._text == "Drug")
        .map(i => i.intervention_name._text)
        .sort()
        .filter(this.unique)
        .join(", ")
      );
    }
    return null;
  }

  public get locations(): string {
    if (this.trial) {

      // In clinical_study, location can be a TrialLocation or a TrialLocation[]. Should be always an array.
      let locations: TrialLocation[];
      if (this.trial.clinical_study.location instanceof Array) {
        locations = this.trial.clinical_study.location;
      } else {
        locations = [this.trial.clinical_study.location];
      }

      return this.strip(locations
        .map(x => x.facility.name._text)
        .sort()
        .filter(this.unique)
        .join(", ")
      );
    }
  }

  private strip(text: string): string {
    const n = 300;
    if (text && text.length > n) {
      text = text.substring(0, n) + "...";
    }
    return text;
  }

  openTrial() {
    const url = 'https://clinicaltrials.gov/ct2/show/record/' + this.trial.trialId;
    const name = 'CTGov';
    window.open(url, name);
  }

  get abbreviatedTitle() {
    const max = 50;
    let text = this.trial.clinical_study.brief_title._text;
    if (text.length > max) {
      text = text.substring(0, max) + "...";
    }
    return text;
  }
}


